/*
 * Copyright 2018-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
 * in compliance with the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations under the License.
 */

<template>
  <div class="caption-editor">
    <awsui-tabs :titles="['BPM', 'Metadata', 'Raw']">
      <!-- <template slot="Smart" >
        <cues-editor-smart
          :captions="captions"
          @error="showError"
        />
      </template>-->
      <template slot="Raw">
        <textarea
          v-model="input"
          :disabled="disabled"
          class="webvtt-input"
          spellcheck="true"
        />
      </template>
      <!-- <template slot="Details" >
        <div class="table-full">
          <div class="table-head">
            <div class="table-cell">
              <span class="awsui-form-field-label">Identifier</span>
            </div>
            <div class="table-cell">
              <span class="awsui-form-field-label">Start</span>
            </div>
            <div class="table-cell">
              <span class="awsui-form-field-label">End</span>
            </div>
            <div class="table-cell">
              <span class="awsui-form-field-label">Style</span>
            </div>
            <div class="table-cell">
              <span class="awsui-form-field-label">Text</span>
            </div>
          </div>
          <cue-editor
            v-for="(item, index) in captions"
            :key="index"
            :end="item.end"
            :identifier="item.identifier"
            :start="item.start"
            :styles="item.styles"
            :text="item.text"
            :remove="true"
            @remove="removeCue(index)"
            @error="showError"
            @end="updateValue(index, 'end', $event)"
            @identifier="updateValue(index, 'identifier', $event)"
            @start="updateValue(index,'start', $event)"
            @styles="updateValue(index, 'styles', $event)"
            @text="updateValue(index, 'text', $event)"
          />
        </div>
        <cue-creator @save="addCue" />
      </template>-->
      <template slot="BPM">
        <label>
          <span>BPM</span>
          <input
            v-model.number="bpm"
            type="number"
            min="10"
            max="200"
          >
        </label>
        <label>
          <span>Offset (seconds)</span>
          <input
            v-model.number="offset"
            type="number"
            min="0"
            max="4"
            step="0.1"
          >
        </label>
      </template>
      <template slot="Metadata">
        <textarea
          v-model="bpmInput"
          :disabled="disabled"
          class="webvtt-input"
          spellcheck="true"
        />
      </template>
    </awsui-tabs>
  </div>
</template>

<script>
// X-TIMESTAMP-MAP=MPEGTS:0,LOCAL:00:00:00.000
import * as webvtt from 'node-webvtt'
// import AwsuiButton from "./AwsuiButton.vue";
// import AwsuiFormField from './AwsuiFormField.vue';
import AwsuiTabs from './AwsuiTabs.vue'
// import ClickEditInput from "./ClickEditInput.vue";
// import CueCreator from "./CueCreator.vue";
// import CueEditor from "./CueEditor.vue";
// import CuesEditorSmart from './CuesEditorSmart.vue';
// import TimeInput from "./TimeInput.vue";

export default {
  name: 'CaptionEditor',
  components: {
    // AwsuiButton,
    // AwsuiFormField,
    AwsuiTabs
    // ClickEditInput,
    // CueCreator,
    // CueEditor,
    // CuesEditorSmart,
    // TimeInput
  },
  props: {
    disabled: {
      default: false,
      type: Boolean
    },
    /**
     * default text displayed if empty caption
     */
    text: {
      default: '',
      type: String
    },
    /**
     * Saved value of raw WebVTT file
     */
    value: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      bpm: 135,
      bpmInput: '{"cues": []}',
      /**
       * parsed cue objects
       */
      captions: [],
      editError: '',
      error: '',
      index: 0,
      /**
       * Draft of new raw WebVTT file
       */
      input: '',
      offset: 0.5
    }
  },
  watch: {
    bpm () {
      this.buildBpmCues()
    },
    bpmInput (newVal) {
      const temp = JSON.parse(newVal).cues
      if (this.text) {
        for (const cue in temp) {
          temp[cue].text = temp[cue].text || this.text
        }
      }
      this.captions = temp
    },
    captions: {
      handler (newVal) {
        try {
          // this.$logger.debug('caption-editor compile', newVal);
          const temp = webvtt.compile({ cues: newVal, valid: true })
          this.bpmInput = JSON.stringify({ cues: newVal })
          this.input = temp
          this.$emit('input', temp)
        } catch (err) {
          this.showEditError(err)
        }
      },
      deep: true
    },
    disabled () {},
    input (newVal) {
      if (typeof newVal === 'string') {
        this.$emit('input', newVal.trim())
      } else {
        this.$emit('input', newVal)
      }
    },
    offset () {
      this.buildBpmCues()
    },
    text () {
      this.buildBpmCues()
    },
    value (newVal, oldVal) {
      if (newVal !== oldVal) {
        try {
          const temp = webvtt.parse(newVal.trim())
          temp.cues = temp.cues || []
          if (this.captions !== temp.cues) {
            this.captions = temp.cues.sort((a, b) => {
              if (a.start > b.start) {
                return 1
              }
              if (a.start < b.start) {
                return -1
              }
              return 0
            })
            this.$logger.debug('caption-parse', temp)
          }
        } catch (err) {
          // this.showError(err);
          this.$logger.error('caption-parse-error', err)
          // TODO: spellcheck for WebVTT
        }
        this.input = this.value
      }
    }
  },
  mounted () {
    this.input = this.value
    this.buildBpmCues()
  },
  methods: {
    addCue (cue) {
      this.captions.push(cue)
    },
    buildBpmCues () {
      const modifier = 0.3
      const diff = 60.0 / this.bpm
      const cutoff = diff * modifier

      // const total = 360
      const total = 167

      let curr = this.offset // || 0.0

      const newCaps = []
      let i = 1

      while (curr < total) {
        const endTime = curr + cutoff
        // text: `${curr}`,
        newCaps.push({
          start: curr,
          end: endTime,
          text: `${this.text}`,
          identifier: `${i}`,
          styles: 'line:2'
        })
        // styles: 'line:0'
        curr += diff
        i++
        // console.log('curr', curr)
      }
      this.captions = newCaps
    },
    removeCue (index) {
      this.captions.splice(index, 1)
    },
    showEditError (err) {
      this.editError = err
      this.$logger.error('caption-editor', err)
    },
    showError (err) {
      this.$logger.error('caption-editor', err)
      this.$emit('error', err)
    },
    updateValue (index, key, value) {
      const tempObj = {}
      tempObj[key] = value
      const newVal = Object.assign(this.captions[index], tempObj)
      this.$set(this.captions, index, newVal)
    }
  }
}
</script>
<style lang="scss">
.caption-editor {
  width: 100%;
}
.table-full {
  display: table;
  width: 100%;
}
.table-head {
  display: table-row;
}
.table-cell {
  display: table-cell;
}
.webvtt-input {
  width: 100%;
  min-height: 200px;
  max-height: 50vh;
}
</style>
